export const PossibleTransitionValues = ["a", "b", "^"];
